import { useNotificationsStore } from "@/stores/modules/notifications/notifications";
import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";

/**
 * Requests an FCM token from Flutter
 */
export function askFcmTokenFlutter(): void {
  sendMessageToFlutter(FlutterChannel.FCM);
}

/**
 * Sets the notification permission status
 */
export function setNotificationPermissionStatus(status: string): void {
  const notificationsStore = useNotificationsStore();
  notificationsStore.setHasMobileNotificationPermission(JSON.parse(status));
}

/**
 * Registers an FCM token with the backend
 */
export function registerFcmToken(fcmToken: string): void {
  const notificationsStore = useNotificationsStore();
  notificationsStore
    .registerMessageToken(fcmToken)
    .then(() => {
      //
    })
    .catch(() => {
      //
    });
}
